import Sortable from 'sortablejs'

export default {
  mounted(el, binding) {
    // 获取表头元素
    const headerRow = el.querySelector('.el-table__header-wrapper tr')
    
    if (headerRow) {
      // 获取所有表头单元格
      const headerCells = headerRow.querySelectorAll('th')
      
      // 禁用第一列（序号列）和最后一列（操作列）的拖拽
      if (headerCells.length > 0) {
        // 禁用第一个单元格（序号列）
        headerCells[0].classList.add('disabled-drag')
        
        // 禁用最后一个单元格（操作列）
        headerCells[headerCells.length - 1].classList.add('disabled-drag')
      }
      
      // 创建表头拖拽
      const sortable = Sortable.create(headerRow, {
        animation: 150,
        filter: '.disabled-drag', // 禁用带有.disabled-drag类的元素拖拽
        onMove: function (evt) {
          // 阻止将其他列拖拽到第一列（序号列）位置
          if (evt.relatedIndex === 0) {
            return false;
          }
          
          // 阻止将其他列拖拽到最后一个位置（操作列位置）
          const totalColumns = headerRow.querySelectorAll('th').length;
          if (evt.relatedIndex === totalColumns - 1) {
            return false;
          }
          
          // 阻止拖拽到固定列
          if (evt.related && evt.related.classList.contains('disabled-drag')) {
            return false;
          }
          
          return true;
        },
        onEnd: (evt) => {
          const { oldIndex, newIndex } = evt
          
          // 调用回调函数，让组件自己处理数据
          if (binding.value && typeof binding.value.onColumnDrop === 'function') {
            binding.value.onColumnDrop(oldIndex, newIndex)
          }
        }
      })
      
      // 保存sortable实例
      el.sortableInstance = sortable
    }
  },
  
  unmounted(el) {
    // 组件销毁时清理拖拽实例
    if (el.sortableInstance) {
      el.sortableInstance.destroy()
      delete el.sortableInstance
    }
  }
}